import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ConfigSistemaForm } from "./form";
const ConfigSistemaFormRx = componentToRx(ConfigSistemaForm);
type Entity = models.ConfigSistemaDTO;
const resource = resources.ConfigSistema;

interface Props {
}
interface State {
    value: Promise<Entity> | Entity;
}
class ConfigSistemaEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }

    async getValue() {
        return (await resource.Get()) || models.configSistemaInicial;
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const func = resource.Update;
        const value = await this.state.value;
        await func(value);
        await kea.message("Configuración actualizada", undefined, "success");
    }

    render() {
        const props = this.props;
        return <ConfigSistemaFormRx
            value={this.state.value}
            onChange={this.onChange}
            onGuardar={this.onGuardar} />;
    }
}

export const ConfigSistema = withRouter(ConfigSistemaEditComp);




// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/edit.tsx